

































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRouterLink
  }
})
export default class extends Mixins(Common) {
  @Prop(Object) readonly option!: object
  @Prop(Number) readonly colCount!: number
  @Prop(Number) readonly rank!: number
  @Prop(Object) readonly item!: {
    id: string;
    price: number;
    orgPrice: number;
  }

  get discountRate () {
    if (!this.item.orgPrice) return undefined
    return Math.round((this.item.orgPrice - this.item.price) * 100 / this.item.orgPrice)
  }
}
